export * from './campagne.model';
export * from './campagne-popup.service';
export * from './campagne.service';
export * from './campagne-dialog.component';
export * from './campagne-formations-dialog.component';
export * from './campagne-detail.component';
export * from './campagne.component';
export * from './campagne.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/campagne/index.ts